import 'babel-polyfill';
import 'url-search-params-polyfill';
import 'whatwg-fetch';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import ReactGA from 'react-ga';
import createHistory from 'history/createBrowserHistory';
import configureStore from '@redux-core';
import Root from '@navigation';
import config from '@config';

// msal.js
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication, NavigationClient } from '@azure/msal-browser';
import { ProxyNavigationClient } from '@utils';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'toastr/build/toastr.css';
import 'animate.css';
import '../scss/index.scss';

const navigationClient = config.ENV_OPTIONS.adb2c.proxyUrl !== undefined
	? new ProxyNavigationClient(config.ENV_OPTIONS.adb2c.proxyUrl)
	: new NavigationClient();

// Create PublicClientApplication instance
const msalInstance = new PublicClientApplication({
	auth   : config.ENV_OPTIONS.adb2c.auth,
	cache  : config.ENV_OPTIONS.adb2c.cache,
	system : { navigationClient },
});

const history = createHistory();
const { store, persistor } = configureStore(history, msalInstance);

ReactGA.initialize(config.GA_KEY);

// set a token passed via 'auth' param, i.e. SSO redirect
const { search, hash } = window.location;
let authToken;
if (search.indexOf('auth=token') > -1) { authToken = hash.substr(hash.indexOf('token=') + 6); }

if (authToken) localStorage.setItem('t', authToken);

history.listen((location) => {
	if (config.useAnalytics) ReactGA.pageview(location.pathname + location.search);

	window.scrollTo(0, 0);
});

render((
	<Provider store={store}>
		<PersistGate persistor={persistor}>
			<MsalProvider instance={msalInstance}>
				<Root history={history} />
			</MsalProvider>
		</PersistGate>
	</Provider>
), document.getElementById('app'));
